import { useInsertionEffect } from 'react';

export const useTitle = (title: string) => {
  useInsertionEffect(() => {
    const currentTitle = document.title;
    if (title !== currentTitle) {
      document.title = `${title}-${TITLE}`;
      return () => {
        document.title = currentTitle;
      };
    }
  }, []);
};
